import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./baseQuery";

export const groupsApi = createApi({
  reducerPath: "panelGroups",
  baseQuery: axiosBaseQuery(),
  // Sekmeye geri dönüşte ve bağlantı gelince yenile; bir bileşen mount olduğunda
  // cache 30 sn'den eskiyse tekrar çek. Böylece sayfa yenilemeye gerek kalmaz.
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: 30,
  tagTypes: ["MyGroups", "GroupPublicInfo", "GroupFeed", "GroupProgress", "GroupMember"],
  endpoints: (builder) => ({
    getMyGroups: builder.query({
      query: () => ({
        url: "/api/panel/users/get-my-groups",
        method: "POST",
        data: {},
      }),
      providesTags: ["MyGroups"],
    }),
    joinGroupByQR: builder.mutation({
      query: ({ groupId, templateId }) => ({
        url: "/api/panel/users/join-group-by-qr",
        method: "POST",
        data: { groupId, templateId },
      }),
      invalidatesTags: ["MyGroups"],
    }),
    leaveMyGroup: builder.mutation({
      query: ({ groupId }) => ({
        url: "/api/panel/users/leave-my-group",
        method: "POST",
        data: { groupId },
      }),
      invalidatesTags: ["MyGroups"],
    }),
    // Grup akışı (Enler / Olaylar ve Ünvanlar): dönem özeti, öne çıkanlar,
    // kilometre taşları ve İlim Meclisi ünvanları. Mobil uçla aynı; yalnız JWT
    // ister, üyeler de görebilir. startDate/endDate verilmezse bu hafta.
    getGroupFeed: builder.query({
      query: ({ groupId, startDate, endDate }) => ({
        url: "/api/groups/get-group-feed",
        method: "POST",
        data: { groupId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      }),
      providesTags: (result, error, { groupId }) => [{ type: "GroupFeed", id: groupId }],
    }),
    // Grup sıralaması (İstatistik): üyelerin dönem tamamlaması, seri, odak.
    getGroupProgress: builder.query({
      query: ({ groupId, startDate, endDate }) => ({
        url: "/api/groups/get-group-progress",
        method: "POST",
        data: { groupId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      }),
      providesTags: (result, error, { groupId }) => [{ type: "GroupProgress", id: groupId }],
    }),
    // Gruptaki bir kardeşin künyesi (dönem özeti) ve ünvanları. Mobil uç;
    // üyeler de görebilir.
    getGroupMember: builder.query({
      query: ({ groupId, memberId, startDate, endDate }) => ({
        url: "/api/groups/get-group-member",
        method: "POST",
        data: { groupId, memberId, ...(startDate && endDate ? { startDate, endDate } : {}) },
      }),
      providesTags: (result, error, { groupId, memberId }) => [
        { type: "GroupMember", id: `${groupId}/${memberId}` },
      ],
    }),
    getGroupPublicInfo: builder.query({
      query: ({ groupId, templateId }) => ({
        url: "/api/panel/groups/get-public-info",
        method: "POST",
        data: { groupId, templateId },
      }),
      providesTags: (result, error, { groupId, templateId }) => [
        { type: "GroupPublicInfo", id: `${groupId}/${templateId}` },
      ],
    }),
  }),
});

export const {
  useGetMyGroupsQuery,
  useJoinGroupByQRMutation,
  useLeaveMyGroupMutation,
  useLazyGetGroupPublicInfoQuery,
  useGetGroupFeedQuery,
  useGetGroupProgressQuery,
  useGetGroupMemberQuery,
} = groupsApi;
